'use strict';

define('vb/private/stateManagement/application',['vb/private/stateManagement/applicationClass'], (ApplicationClass) => new ApplicationClass());

